// Shopify owns the country context and currency conversion. Reload through its native form.
export function localizationReturnTo(location) {
  return location.pathname + location.search;
}

if (typeof document !== 'undefined') {
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-country-auto-submit]')) return;
    const mobileNav = event.target.closest('.mobile-navigation');
    if (mobileNav) {
      mobileNav.hidden = true;
      const toggle = Array.from(document.querySelectorAll('[data-menu-toggle]')).find(button => button.getAttribute('aria-controls') === mobileNav.id);
      toggle?.setAttribute('aria-expanded', 'false');
      toggle?.focus({preventScroll: true});
    }
    event.target.form.requestSubmit();
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form.matches('.country-selector-form')) return;
    let returnTo = form.querySelector('[name="return_to"]');
    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.append(returnTo);
    }
    // Keep search filters and the selected variant, including changes made after page load.
    returnTo.value = localizationReturnTo(window.location);
  });
}
